import React, { Component } from 'react';
import {
    Layout,
    Button,
    DatePicker,
    PageHeader,
    Tag,
} from 'antd';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import HeaderComponent from '../../components/HeaderComponent';
import ReactTable from 'react-table';
import { debounce } from '../../utils';
import {getAllCenters} from '../../services/api/all-centers';
import Papa from 'papaparse';
import SidebarComponent from '../../components/sidebarComponent';

const { Content } = Layout;
const { RangePicker } = DatePicker;

class CenterListing extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            bgColor: '',
            data: [],
            dataForCsv: [],
            pageSize: 10,
            pages: 0,
            totalHits: '',
            filtered: [],
            visitSpocNames:[],
            createdAtStartDate: null,
            createdAtEndDate: null, 
            selectedReason: null,
            isSidebarOpen: true,
            states : [
                "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh", "Goa",
                "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka", "Kerala",
                "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram", "Nagaland",
                "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura",
                "Uttar Pradesh", "Uttarakhand", "West Bengal", "Andaman and Nicobar Islands",
                "Chandigarh", "Dadra and Nagar Haveli and Daman and Diu", "Lakshadweep",
                "Delhi", "Puducherry", "Ladakh", "Lakshadweep", "Jammu and Kashmir"
            ],
        };
        this.fetchDataWithDebounce = debounce(this.onFilteredChange, 300);
    }
    toggleSidebar = () => {
        this.setState({
            isSidebarOpen: !this.state.isSidebarOpen,
        });
    };
    tableColumns = [
        // Existing columns remain unchanged

        {
            accessor: 'centerId',
            Header: 'Center ID',
            filterable: true,
            Cell: ({ value }) => {
                return (
                    <div
                        style={{ color: '#445DE4' ,
                            cursor: 'pointer'
                        }}
                        onClick={() => {
                            // Navigate to center profile page
                            window.location.href = `/center-profile/${value}`;
                        }}
                        // mouse pointer on hover
                    >
                        {value}
                    </div>
                )
                
            },
            Filter: ({ filter, onChange }) => (
                <input
                    placeholder="Search..."
                    value={filter ? filter.value : ''}
                    onChange={(event) => onChange(event.target.value)}
                />
            ),
        },
        {
            accessor: 'centerName',
            Header: 'Center Name',
            filterable: true,
            Filter: ({ filter, onChange }) => (
                <input
                    placeholder="Search..."
                    value={filter ? filter.value : ''}
                    onChange={(event) => onChange(event.target.value)}
                />
            ),
        },
        {
            accessor: 'centerAddress',
            Header: 'Center Address',
            filterable: true,
            width:200,
            Filter: ({ filter, onChange }) => (
                <input
                    placeholder="Search..."
                    value={filter ? filter.value : ''}
                    onChange={(event) => onChange(event.target.value)}
                />
            ),
        },
        {
            accessor: 'city',
            Header: 'City',
            filterable: true,
            Filter: ({ filter, onChange }) => (
                <input
                    placeholder="Search..."
                    value={filter ? filter.value : ''}
                    onChange={(event) => onChange(event.target.value)}
                />
            ),
        },
        {
            accessor: 'state',
            Header: 'State',
            filterable: true,
            Filter: ({ filter, onChange }) => (
                <select
                    onChange={(event) => onChange(event.target.value)}
                    value={filter ? filter.value : 'all'}
                    style={{ width: '100%' }}
                >
                    <option value="">All</option>
                    {this.state.states.map((state, index) => (
                        <option key={index} value={state}>{state}</option>
                    ))}
                </select>
            ),
        },
        // {
        //     accessor: 'status',
        //     Header: 'Status',
        //     filterable: true,
        //     // if value is 1 , value is yes otherwies no
        //     Cell: ({ value, row }) => {
                
        //         const empanellmentStatus = row.empanellmentStatus || row.original.empanellmentStatus || row.values.empanellmentStatus;
        //         console.log(empanellmentStatus, "empanellmentstatus");
        //         // You can now use empanellmentStatus here
        //        let displayText = value === 1 ? 'Yes' : 'No';
        // let style = { border: '1px solid', padding: '5px', borderRadius: '5px' };

        // if (empanellmentStatus === 'empanelled') {
        //     displayText = 'Empanelled';
        //     style = { ...style, backgroundColor: '#e3f7ff', borderColor: '#0099cc', color: '#007acc' }; // Blue box
        // } else if (value === 1) {
        //     displayText = 'Yes';
        //     style = { ...style, backgroundColor: '#d4f5d0', borderColor: '#28a745', color: '#28a745' }; // Green box
        // } else {
        //     displayText = 'No';
        //     style = { ...style, backgroundColor: '#f8d7da', borderColor: '#dc3545', color: '#dc3545' }; // Red box
        // }

        // return <span style={style}>{displayText}</span>;
        //     },
        //     Filter: ({ filter, onChange }) => (
        //         <select
        //             onChange={(event) => onChange(event.target.value)}
        //             value={filter ? filter.value : 'all'}
        //             style={{ width: '100%' }}
        //         >
        //             <option value="">All</option>
        //             <option value="1">Yes</option>
        //             <option value="0">No</option>
        //             <option value="empanelled">Empanelled</option>
        //         </select>
        //     ),
        // },
        {
            accessor: 'status',
            Header: 'Status',
            filterable: true,
            Cell: ({ value }) => {
                return value === 1 ? 'Yes' : <span style={{ color: 'red' }}>No</span>;
            },
            Filter: ({ filter, onChange }) => (
                <select
                    onChange={(event) => onChange(event.target.value)}
                    value={filter ? filter.value : 'all'}
                    style={{ width: '100%' }}
                >
                    <option value="">All</option>
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                </select>
            ),
        },

        {
            accessor: 'empanellmentStatus',
            Header: 'Empanelment Status',
            filterable: true,
            width:200,
            Cell: ({ value }) => {
                return value === 'empanelled' ? <span >Empanelled</span> : <span style={{ color: 'red' }}>Depanelled</span>;
            },
            Filter: ({ filter, onChange }) => (
                <select
                    onChange={(event) => onChange(event.target.value)}
                    value={filter ? filter.value : 'all'}
                    style={{ width: '100%' }}
                >
                    <option value="">All</option>
                    <option value="empanelled">Empanelled</option>
                    <option value="depanelled">Depanelled</option>
                </select>
            ),
        },
        {
            accessor: 'specialEmpanellment',
            Header: 'Special Empanelment',
            filterable: true,
            width:150,
            Cell: ({ value }) => {
                return value === 1 ? 'Yes' : <span style={{ color: 'red' }}>No</span>;
            },
            Filter: ({ filter, onChange }) => (
                <select
                    onChange={(event) => onChange(event.target.value)}
                    value={filter ? filter.value : 'all'}
                    style={{ width: '100%' }}
                >
                    <option value="">All</option>
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                </select>
            ),
        },
        {
            accessor: 'prebookCenter',
            Header: 'Prebook Center',
            filterable: true,
            width:150 ,
            Cell: ({ value }) => {
                return value === 1 ? 'Yes' : <span style={{ color: 'red' }}>No</span>;
            },
            Filter: ({ filter, onChange }) => (
                <select
                    onChange={(event) => onChange(event.target.value)}
                    value={filter ? filter.value : 'all'}
                    style={{ width: '100%' }}
                >
                    <option value="">All</option>
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                </select>
            ),
        },
        {
            accessor: 'keaDashboard',
            Header: 'Kea Dashboard',
            filterable: true,
            width:150,
            Cell: ({ value }) => {
                // if value ==0 style no with red colour else standard color

                return value === 1 ? 'Yes' : <span style={{ color: 'red' }}>No</span>;
            },
            Filter: ({ filter, onChange }) => (
                <select
                    onChange={(event) => onChange(event.target.value)}
                    value={filter ? filter.value : 'all'}
                    style={{ width: '100%' }}
                >
                    <option value="">All</option>
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                </select>
            ),
        },
        {
            accessor: 'mouExpiry',
            Header: 'MOU Expiry',
            filterable: true,
            Cell: ({ value }) => {
                const currentDate = new Date();
                const daysDifference = Math.floor((new Date(value) - currentDate) / (1000 * 60 * 60 * 24));

                if (daysDifference > 0 && daysDifference <= 45) {
                    return <span>{daysDifference} days</span>;
                } else if (daysDifference <= 0) {
                    return <span style={{ color: 'red' }}>Expired</span>;
                } else {
                    return <span>-</span>;
                }
            },
            Filter: ({ filter, onChange }) => (
                <select
                    onChange={(event) => onChange(event.target.value)}
                    value={filter ? filter.value : ''}
                    style={{ width: '100%' }}
                >
                    <option value="">All</option>
                    <option value="1-5">1-5 Days</option>
                    <option value="6-10">6-10 Days</option>
                    <option value="11-15">11-15 Days</option>
                    <option value="16-20">16-20 Days</option>
                    <option value="21-25">21-25 Days</option>
                    <option value="26-30">26-30 Days</option>
                    <option value="31-35">31-35 Days</option>
                    <option value="36-40">36-40 Days</option>
                    <option value="41-45">41-45 Days</option>
                    <option value="expired">Expired</option>
                </select>
            ),
            filterMethod: (filter, row) => {
                const currentDate = new Date();
                const expiryDate = new Date(row[filter.id]);
                const daysDifference = Math.floor((expiryDate - currentDate) / (1000 * 60 * 60 * 24));

                if (filter.value === "expired") {
                    return daysDifference <= 0;
                }

                const [min, max] = filter.value.split('-').map(Number);
                return daysDifference >= min && daysDifference <= max;
            },
        },
        {
            accessor: 'zohoCompanyName',
            Header: 'Company Name',
            filterable: true,
            width:200,
            Filter: ({ filter, onChange }) => (
                <input
                    placeholder="Search..."
                    value={filter ? filter.value : ''}
                    onChange={(event) => onChange(event.target.value)}
                />
            ),
        },
        {
            accessor: 'pan',
            Header: 'PAN',
            filterable: true,
            Cell: ({ value }) => {
                // if value ==0 style no with red colour else standard color

                return value === 1 ? 'Yes' : <span style={{ color: 'red' }}>No</span>;
            },
            Filter: ({ filter, onChange }) => (
                <select
                    onChange={(event) => onChange(event.target.value)}
                    value={filter ? filter.value : 'all'}
                    style={{ width: '100%' }}
                >
                    <option value="">All</option>
                    <option value="1">Yes</option>
                    <option value="0">No</option>
                </select>
            ),
        },
        {
            accessor: 'visitSpocName',
            Header: 'Visit SPOC Name',
            filterable: true,
            width:200,
            Filter: ({ filter, onChange }) => (
                <select
                    onChange={(event) => onChange(event.target.value)}
                    value={filter ? filter.value : ''} // Set the value to the selected id
                    style={{ width: '100%' }}
                >
                    <option value="">All</option>
                    {this.state.visitSpocNames.map((spoc, index) => (
                        <option key={index} value={spoc.id}>{spoc.name}</option>
                    ))}
                </select>
            ),
        },
        {
            accessor: 'totalDoctors',
            Header: 'Total Doctors',
        },
        {
            accessor: 'activeDoctors',
            Header: 'Active Doctors',
            width:130,
        },
        {
            accessor: 'createdOn',
            Header: 'Created On',
            width:230,
            filterable: true,
            Filter: ({ filter, onChange }) => (
                <RangePicker 
                    onChange={this.handleDateChange}
                    placeholder={['Start Date (YYYY-MM-DD)', 'End Date (YYYY-MM-DD)']} 
                    style={{ width: '100%' }} />

            ),
        },

        // Other existing columns
    ];
   
  
    // Fetch Table Data
    onFetchData = (state) => {
        let orderBy, orderDir;
        if (state.sorted.length > 0) {
            orderBy = state.sorted[0].id;
            orderDir = state.sorted[0].desc ? 'desc' : 'asc';
        } else {
            orderBy = 'requestId';
            orderDir = 'DESC';
        }
        this.setState(
            {
                pageSize: state.pageSize,
                page: state.page,
                orderBy,
                orderDir,
            },
            this.fetchTableData
        );
    };

    handleDateChange = (dates, dateStrings) => {
        this.setState(
            {
                createdAtStartDate: dateStrings[0],
                createdAtEndDate: dateStrings[1],
            },
            this.fetchTableData // Automatically call the API after setting the date range
        );
    };


    downloadCsv = () => {

        this.setState({
            loading: true,
        });
        const params = {
            rowsPerPage: 1000000,
            page: this.state.page,
            orderBy: this.state.orderBy,
            orderDir: this.state.orderDir,
        };
        const { createdAtStartDate, createdAtEndDate } = this.state;  
        if (createdAtStartDate && createdAtEndDate) {
            params.createdAtStartDate = createdAtStartDate;
            params.createdAtEndDate = createdAtEndDate;
        }
        if (this.state.filtered.length !== 0) {
            this.state.filtered.forEach((element) => {
                if (element.id === 'centerId') params.centerId = element.value;
                if (element.id === 'centerName') params.centerName = element.value;
                if (element.id === 'centerAddress') params.centerAddress = element.value;
                if (element.id === 'city') params.city = element.value;
                if (element.id === 'state') params.state = element.value;
                if (element.id === 'status') params.status = element.value;
                if (element.id === 'empanellmentStatus') params.empanellmentStatus = element.value;
                if (element.id === 'specialEmpanellment') params.specialEmpanellment = element.value;
                if (element.id === 'prebookCenter') params.prebookCenter = element.value;
                if (element.id === 'keaDashboard') params.keaDashboard = element.value;
                if (element.id === 'createdOn') params.createdOn = element.value;
                if (element.id === 'mouExpiry') params.mouExpiry = element.value;
                if (element.id === 'zohoCompanyName') params.zohoCompanyName = element.value;
                if (element.id === 'pan') params.pan = element.value;
                if (element.id === 'visitSpocName') params.visitSpocName = element.value;
            });
        }
        getAllCenters(params)
            .then((responseBody) => {
                console.log({ responseBody });
                this.setState({
                    loading: false,
                });


                const fields = [
                    { label: "Center Id", value: "centerId" },
                    { label: "Center Name", value: "centerName" },
                    { label: "Center Address", value: "centerAddress" },
                    { label: "City", value: "city" },
                    { label: "State", value: "state" },
                    { label: "Status", value: "status" },
                    { label: "Empanellment Status", value: "empanellmentStatus" },
                    { label: "Special Empanellment", value: "specialEmpanellment" },
                    { label: "Prebook Center", value: "prebookCenter" },
                    { label: "KEA Dashboard", value: "keaDashboard" },
                    { label: "Created On", value: "createdOn" },
                    { label: "MOU Expiry", value: "mouExpiry" },
                    { label: "Zoho Company Name", value: "zohoCompanyName" },
                    { label: "PAN", value: "pan" },
                    { label: "Visit SPOC Name", value: "visitSpocName" },
                    { label: "Total Doctors", value: "totalDoctors" },
                    { label: "Active Doctors", value: "activeDoctors" },
                   
                ];

                const filteredData = responseBody.body.data.centerDetails.map(item => {
                    const filteredItem = {};
                    fields.forEach(field => {
                        filteredItem[field.label] = item[field.value];
                    });
                    return filteredItem;
                });

                const csv = Papa.unparse(filteredData, {
                    header: true
                });

                const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });

                const link = document.createElement('a');
                const url = URL.createObjectURL(blob);
                link.setAttribute('href', url);
                link.setAttribute('download', `${new Date().toISOString().split('T')[0]}_all_centers_data.csv`);
                document.body.appendChild(link);

                link.click();
                document.body.removeChild(link);
            })
    };

    fetchTableData = () => {
        this.setState({
            loading: true,
        });
        // console.log(this.state.filtered.length, this.state.filtered[0]);

        const params = {
            rowsPerPage: this.state.pageSize,
            page: this.state.page,
            orderBy: this.state.orderBy,
            orderDir: this.state.orderDir,
        };

        const { createdAtStartDate, createdAtEndDate } = this.state;  // Get date range from state
        if (createdAtStartDate && createdAtEndDate) {
            params.createdAtStartDate = createdAtStartDate;
            params.createdAtEndDate = createdAtEndDate;
        }
        if (this.state.filtered.length !== 0) {
            this.state.filtered.forEach((element) => {
                // console.log({element});
                if (element.id === 'centerId') params.centerId = element.value;
                if (element.id === 'centerName') params.centerName = element.value;
                if (element.id === 'centerAddress') params.centerAddress = element.value;
                if (element.id === 'city') params.city = element.value;
                if (element.id === 'state') params.state = element.value;
                if (element.id === 'status') params.status = element.value;
                if (element.id === 'empanellmentStatus') params.empanellmentStatus = element.value;
                if (element.id === 'specialEmpanellment') params.specialEmpanellment = element.value;
                if (element.id === 'prebookCenter') params.prebookCenter = element.value;
                if (element.id === 'keaDashboard') params.keaDashboard = element.value;
                if (element.id === 'createdOn') params.createdOn = element.value;
                if (element.id === 'mouExpiry') params.mouExpiry = element.value;
                if (element.id === 'zohoCompanyName') params.zohoCompanyName = element.value;
                if (element.id === 'pan') params.pan = element.value;
                if (element.id === 'visitSpocName') params.visitSpocName = element.value;
                // createdAtStartDate: dateRange[0], // Start date
                    // createdAtEndDate: dateRange[1],
            });
        }
        // console.log(params);

        getAllCenters(params)
            .then((responseBody) => {
                console.log({ responseBody });
                this.setState({
                    data: responseBody.body.data.centerDetails,
                    loading: false,
                    totalHits: responseBody.body.data.totalHits,
                    visitSpocNames: responseBody.body.data.visitSpocDetails.map((item) => ({
                        name: item.visitSpocName,
                        id: item.id,
                    })),                    
                    pages: Math.ceil(responseBody.body.data.totalHits / this.state.pageSize),
                });
            })
            .catch((err) => {
                console.log(err);
                let errorMessage = err.message;
                this.setState({
                    showModal: true,
                    modalHeader: 'Error',
                    modalBody: `${errorMessage}.`,
                    bgColor: 'bg-danger',
                    loading: false,
                });
            });
    };
    onFilteredChange = (e) => {
        // console.log(e);
        this.setState({ filtered: e });
    };
    render() {
        const { isSidebarOpen } = this.state;
        return (
            <Layout>
                <div>
                    <HeaderComponent />
                    <div style={{
                        display: 'flex',
                    }}>
                        <div style={{ zIndex: 1000 }}>

                            <SidebarComponent isSidebarOpen={isSidebarOpen}  toggleSidebar={this.toggleSidebar}/>
                        </div>
                        <div
                            style={{ overflow: 'scroll' }}>

                {/* <SubHeaderComponent/> */}
                <Content className="site-layout-background">
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            padding: '24px 32px 24px 32px',

                        }}>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'flex-start',
                                alignContent: 'center',
                            }}>

                            <PageHeader
                                className="site-page-header"
                                title="Center Listing"
                                style={{
                                    padding: '0px',
                                }}
                            />
                            <div>
                                <h3>
                                    <Tag
                                        style={{
                                            background: 'linear-gradient(0deg, #FFFFFF, #FFFFFF), linear-gradient(0deg, rgba(68, 93, 228, 0.1), rgba(68, 93, 228, 0.1))',
                                            color: '#445DE4',
                                            justifyContent: 'center',
                                            display: 'flex',
                                            alignItems: 'center',
                                            padding: '5px 10px',
                                            borderRadius: '5px',
                                            border: '1px solid #445DE433',
                                            backgroundColor: '#FFFFFF',
                                        }}
                                    >
                                        Total: {this.state.totalHits + ' Requests'}
                                    </Tag>
                                </h3>
                            </div>
                        </div>
                        <div style={{ display: 'flex', gap: '10px' }}>
                            <Button type="primary"
                                style={{ backgroundColor: ' #448EF7', }}
                                size="large"
                                onClick={this.downloadCsv}
                            >
                                Download CSV
                            </Button>
                        </div>
                    </div>
                    <div>
                        <ReactTable
                            data={this.state.data}
                            style={{ textAlign: 'center' }}    
                            columns={this.tableColumns}
                            loading={this.state.loading}
                            manual
                            onFetchData={this.onFetchData}
                            onFilteredChange={this.onFilteredChange}
                            className="-striped -highlight"
                            pages={this.state.pages}
                            showPaginationTop
                        />
                    </div>
                </Content>
                </div></div></div>
            </Layout>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.user,
    };
}

export default connect(mapStateToProps)(withRouter(CenterListing));
